var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Hero_tempPosition;
import Condition from "../../core/condition";
export default class Hero {
    constructor({ id, animation, animationLeft, animationRight, animationUp, moveDuration, hidden }) {
        this.type = "hero";
        this.fromPosition = { x: 0, y: 0 };
        _Hero_tempPosition.set(this, { x: 0, y: 0 });
        this.id = id;
        this.animation = animation;
        this.animationLeft = animationLeft;
        this.animationRight = animationRight;
        this.animationUp = animationUp;
        this.moveDuration = moveDuration;
        this.hidden = hidden;
    }
    moveTo(x, y, time, immediate) {
        var _a, _b, _c, _d;
        this.fromPosition.x = (_b = (_a = this.position) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : x;
        this.fromPosition.y = (_d = (_c = this.position) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : y;
        if (!this.position) {
            this.position = { x: 0, y: 0 };
        }
        if (this.position.x !== x || this.position.y !== y) {
            this.moveTime = immediate ? undefined : time;
            this.position.x = x;
            this.position.y = y;
        }
    }
    getAnimation() {
        var _a, _b, _c, _d, _e, _f, _g;
        const dx = ((_b = (_a = this.position) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : this.fromPosition.x) - this.fromPosition.x;
        const dy = ((_d = (_c = this.position) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : this.fromPosition.y) - this.fromPosition.y;
        if (dx !== 0) {
            return dx < 0 ? ((_e = this.animationLeft) !== null && _e !== void 0 ? _e : this.animation) : ((_f = this.animationRight) !== null && _f !== void 0 ? _f : this.animation);
        }
        return dy < 0 ? ((_g = this.animationUp) !== null && _g !== void 0 ? _g : this.animation) : this.animation;
    }
    getTileUnderneath(map) {
        var _a, _b, _c, _d;
        if (this.position) {
            return (_d = map.tiles[(_c = (_b = (_a = map.grid) === null || _a === void 0 ? void 0 : _a[this.position.y]) === null || _b === void 0 ? void 0 : _b[this.position.x]) !== null && _c !== void 0 ? _c : ""]) !== null && _d !== void 0 ? _d : map.defaultTile;
        }
        return map.defaultTile;
    }
    canMoveTo(x, y, map) {
        var _a, _b, _c, _d;
        const tile = (_d = map.tiles[(_c = (_b = (_a = map.grid) === null || _a === void 0 ? void 0 : _a[y]) === null || _b === void 0 ? void 0 : _b[x]) !== null && _c !== void 0 ? _c : ""]) !== null && _d !== void 0 ? _d : map.defaultTile;
        return !Condition.eval(tile === null || tile === void 0 ? void 0 : tile.block, { "scene": map });
    }
    moveBy(dx, dy, time) {
        if (this.isMoving(time)) {
            return;
        }
        if (this.position) {
            this.moveTo(this.position.x + dx, this.position.y + dy, time);
        }
    }
    canMoveBy(dx, dy, map) {
        if (map.destination) {
            return false;
        }
        return this.position && this.canMoveTo(this.position.x + dx, this.position.y + dy, map);
    }
    isMoving(time) {
        var _a, _b;
        const moveDuration = (_a = this.moveDuration) !== null && _a !== void 0 ? _a : .4;
        return time - ((_b = this.moveTime) !== null && _b !== void 0 ? _b : 0) < (moveDuration) * 1000;
    }
    getPosition(time) {
        var _a;
        if (!this.position || !this.moveTime) {
            return this.position;
        }
        const moveDuration = (_a = this.moveDuration) !== null && _a !== void 0 ? _a : .4;
        const progress = moveDuration ? Math.min((time - this.moveTime) / moveDuration / 1000, 1) : 1;
        __classPrivateFieldGet(this, _Hero_tempPosition, "f").x = this.fromPosition.x * (1 - progress) + this.position.x * progress;
        __classPrivateFieldGet(this, _Hero_tempPosition, "f").y = this.fromPosition.y * (1 - progress) + this.position.y * progress;
        return __classPrivateFieldGet(this, _Hero_tempPosition, "f");
    }
    toJSON() {
        return {
            type: this.type,
            animation: this.animation,
            animationLeft: this.animationLeft,
            animationRight: this.animationRight,
            animationUp: this.animationUp,
            position: this.position,
            fromPosition: this.fromPosition,
            moveDuration: this.moveDuration,
            moveTime: this.moveTime,
        };
    }
}
_Hero_tempPosition = new WeakMap();
